import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/login/Login.vue";
import ResidentList from "../views/residents/residents-list/ResidentList.vue";
import FamilyList from "../views/family-members/family-list/FamilyList.vue";
import FamilyView from "../views/family-members/family-view/FamilyView.vue";
import ResidentView from "../views/residents/residents-view/ResidentView.vue";
import Calender from "../views/calender/Calendar.vue";
import PrintableCalendarMain
  from "@/views/calender/printable-calendar-components/printable-calendar-main/PrintableCalendarMain.vue";
import NewCalendarItem from "../views/calender/new-calendar-item/NewCalendarItem.vue";
import ViewCalendarEvent from "../views/calender/view-calendar-item/ViewCalenderItem.vue";
import ViewDigitalSignage from "../views/digital-signage/view-digital-signage/viewDigitalSignage.vue";
import EditDigitalSignage from "../views/digital-signage/edit-digital-signage/editDigitalSignage.vue";
import DigitalSignageList from "../views/digital-signage/digital-signage-list/digitalSignageList.vue";
/*import ConciergeList from "../views/concierge/conciergeList.vue";*/
import MaintenanceView from "../views/maintenance/maintenanceView.vue";
import MaintenanceList from "../views/maintenance/maintenanceList.vue";
import MaintenanceScheduledList from "../views/maintenance/scheduledMaintenance/scheduledMaintenanceList/scheduledMaintenanceList.vue";
import MaintenanceScheduledView from "../views/maintenance/scheduledMaintenance/scheduledMaintenanceView.vue";
import MaintenanceCreateRequest from "../views/maintenance/maintenanceCreateRequest/maintenanceCreateRequest.vue";
import SetMaintenanceUserPassword from "@/views/forgot-password/maintenance-users/SetMaintenanceUserPassword.vue";

import VendorList from "../views/settings/vendorList/VendorList.vue";
import Meeting from "../views/virtual-meeting/meeting.vue";
import MeetingExternal from "../views/virtual-meeting/meetingExternal.vue";
import DevicesList from "../views/devices/devices-list/DevicesList.vue";
import DevicesView from "../views/devices/devices-view/DevicesView.vue";
/*import ContentCreator from "../views/content/list/ContentCreator.vue";*/
import ContentCreatorEditor from "../views/content/ContentCreatorEditor.vue";
import ContentList from "@/views/content/contentList/ContentList.vue";
import ContentView from "@/views/content/contentView/ContentView.vue";
import ContentPreview from "@/views/content/contentPreview/ContentPreview.vue";

import Dashboard from "../views/dashboard/dashboard-view/DashboardView.vue";
import SurveyList from "../views/surveys/surveyList/surveyList.vue";
import SurveyView from "../views/surveys/surveyView/surveyView.vue";
import SurveyForm from "../views/surveys/surveyForm/surveyForm.vue";
import SurveyCreate from "../views/surveys/surveyCreate/surveyCreate.vue";
import ReportList from "../views/reports/reports-list/ReportList.vue";
import VisitsReport from "../views/reports/reports-views/report-visit/ReportVisit.vue";
import additionalServiceRequestsReport from "../views/reports/reports-views/report-requests/ReportRequests.vue";
import AdditionalServiceRequestReportByType from "../views/reports/reports-views/report-requests/ReportByType.vue";
import ConciergeReportByResidents from "../views/reports/reports-views/report-premium-services/ReportByResidents.vue";
import LifestyleEventsReport from "../views/reports/reports-views/report-lifestyleEvents/report-lifestyleEvents/LifestyleEventsReport.vue";
import ResidentsLifestyleEventsReport from "../views/reports/reports-views/report-lifestyleEvents/report-residents-lifestyleEvents/ResidentsLifestyleEventsReport.vue";
import SocialEventsReport from "../views/reports/reports-views/report-events/ReportEvents.vue";
import Report360List from "../views/reports/reports-views/report-360/report-360-list/Report360List.vue";
import Report360View from "../views/reports/reports-views/report-360/report-360-view/Report360View.vue";
import Report360ViewEvents from "../views/reports/reports-views/report-360/report-360-view-events/Report360ViewEvents.vue";
import Report360ViewMedia from "../views/reports/reports-views/report-360/report-360-view-media/Report360ViewMedia.vue";
import Report360ViewServices from "../views/reports/reports-views/report-360/report-360-view-services/Report360ViewServices.vue";
import ReportCommunityDashboard from "@/views/reports/reports-views/report-community-dashboard/ReportCommunityDashboard.vue";
import ReportMaintenance from "@/views/reports/reports-views/report-maintenance/ReportMaintenance.vue";

import Messaging from "../views/staff/messaging/messaging.vue";
import PremiumFeatures from "../views/premium-features/PremiumFeatures.vue";

import Gallery from "../views/staff/gallery/gallery.vue";
import GalleryCameraRoll from "@/views/staff/gallery/GalleryCameraRoll/GalleryCameraRoll.vue";
import GalleryEventPictures from "@/views/staff/gallery/GalleryEventPictures/GalleryEventPictures.vue";
import GalleryEventPicturesView from "@/views/staff/gallery/GalleryEventPicturesView/GalleryEventPicturesView.vue";
import GalleryFolderView from "@/views/staff/gallery/GalleryFolderView/GalleryFolderView.vue";
import GalleryStockPhotos from "@/views/staff/gallery/GalleryStockPhotos/GalleryStockPhotos.vue";

import SocialProgramsList from "../views/social-program/social-programs-list/SocialProgramsList.vue";
import SocialProgramView from "../views/social-program/view-social-program/SocialProgramView.vue";
import CreateSocialProgram from "../views/social-program/create-social-program/CreateSocialProgram.vue";
import GuestBook from "../views/guestbook/guestbook-list/GuestbookList.vue";
import GuestBookVisit from "../views/guestbook/guestbook-view/GuestbookView.vue";
import Settings from "../views/settings/settings/Settings.vue";
import UserDetails from "../views/settings/userDetails.vue";
import EmailTemplateEditor from "../views/settings/emailTemplates/email-view/EmailView.vue";
import EmailTypeManager from "../views/settings/emailTemplates/email-type-manager/EmailTypeManager.vue";
import MailingView from "@/views/settings/mailing/mailingView/MailingView.vue";

import ContentLibraryView from "../views/contentLibrary/contentLibraryView.vue";
import ContentLibraryList from "../views/contentLibrary/contentLibraryList.vue";

import EditPremiumService from "../views/premium-services/edit-premium-services/EditPremiumService.vue";
import PremiumServicesAppointments from "../views/premium-services/premium-services-appointments/PremiumServicesAppointments.vue";

import ConciergeList from "@/views/concierge/concierge-list/ConciergeList.vue";
import ConciergeEvents from "@/views/concierge/concierge-events/ConciergeEvents.vue";
import ConciergeProducts from "@/views/concierge/concierge-products/ConciergeProducts.vue";
import ConciergeRequests from "@/views/concierge/concierge-requests/ConciergeRequests.vue";
import ConciergeService from "@/views/concierge/concierge-service/ConciergeService.vue";
import BookingsAndOrders from "@/views/concierge/bookings-and-orders/homepage/BookingsAndOrders.vue";
import RequestDetails from "@/views/concierge/bookings-and-orders/request-details/RequestDetails.vue";

import DocumentsList from "@/views/documents/documents-list/DocumentsList.vue";
import DocumentsView from "@/views/documents/documents-view/DocumentsView.vue";

//BUDDY
import BuddyFacilities from "../buddy/facilities/listFacilities.vue";
import BuddyFacility from "../buddy/facilities/facility.vue";

import AppLink from "@/views/appLink/AppLink.vue";
import FamilyHubAppLink from "@/views/appLink/FamilyHubAppLink.vue";
import MyHubAppLink from "@/views/appLink/MyHubAppLink.vue";
import ForgotPassword from "@/views/forgot-password/ForgotPassword.vue";
import ResetPassword from "@/views/forgot-password/ResetPassword.vue";
import SetPassword from "@/views/forgot-password/SetPassword.vue";
import SetFamilyHubUserPassword from "@/views/forgot-password/family-hub-user/SetFamilyHubUserPassword.vue";
import VerifyFamilyMemberEmail from "@/views/forgot-password/family-hub-user/VerifyFamilyMemberEmail.vue";
import ResetFamilyHubUserPassword from "@/views/forgot-password/family-hub-user/ResetFamilyHubUserPassword.vue";
import SetVendorPassword from "@/views/forgot-password/vendors/SetVendorPassword.vue";
import CompleteServiceRequest from "@/views/service-request/CompleteServiceRequest.vue";
import Store from "../store/index";
import { FirebaseEmailActions } from "@/enums/FirebaseEmailActions";
import AddToEvent from "../views/external-person/add-to-event/AddToEvent.vue";
import BroadcastsList from "@/views/family-members/broadcasts-list/BroadcastsList.vue";
import PremiumServicesReports from "@/views/reports/reports-views/report-premium-services/ReportPremiumServices.vue";
import UnsubscribeFromEmails from "@/views/unsubscribe-from-emails/UnsubscribeFromEmails.vue";
import PrintableResidentReport360 from "@/views/reports/printable-reports/resident360/resident360-view/PrintableResidentReport360.vue";
import AdHocActivitiesReport from "@/views/reports/reports-views/report-ad-hoc-activities/report-ad-hoc-activities/AdHocActivitiesReport.vue";
import ResidentsAdHocActivitiesReport from "@/views/reports/reports-views/report-ad-hoc-activities/report-residents-ad-hoc-activities/ResidentsAdHocActivitiesReport.vue";
import ResidentAdHocActivitiesReport from "@/views/reports/reports-views/report-ad-hoc-activities/report-resident-ad-hoc-activities/ResidentAdHocActivitiesReport.vue";
import ReportOrganisationDashboard from "@/views/reports/reports-views/report-organisation-dashboard/ReportOrganisationDashboard.vue";
import LifestyleProgramsReport from "@/views/reports/reports-views/report-lifestyle-programs-report/LifestyleProgramsReport.vue";
import i18n from "@/plugins/vueI18n";
import ReportFamily from "@/views/reports/reports-views/report-family/ReportFamily.vue";
import DeleteFamilyHubAccount from "@/views/family-members/delete-account/DeleteFamilyHubAccount.vue";
import { RouteGroup } from "./routeGroup";
import { getEnabledRoute } from "./router-helper";
import GalleryCanvaPhotos from '@/views/staff/gallery/GalleryCanvaPhotos/GalleryCanvaPhotos.vue';
import {StaffAccessLevels} from "@/enums/StaffAccessLevels";
import DigitalSignageTv from '@/views/digital-signage/tv/DigitalSignageTv.vue';
import DigitalSignageTvQRCode from "@/views/digital-signage/tv/digital-signage-tv-QR-code/DigitalSignageTvQRCode.vue";
import DigitalSignageTVLogin from "@/views/digital-signage/tv/digital-signage-tv-login/DigitalSignageTVLogin.vue";
import DigitalSignageTVForgotPassword from "@/views/digital-signage/tv/digital-signage-tv-forgot-password/DigitalSignageTVForgotPassword.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "login",
    component: Login
  },
  {
    path: "/__/auth/action",

    redirect: to => {
      const { mode, oobCode } = to.query;

      switch (mode) {
        case FirebaseEmailActions.ResetPassword:
          return {
            path: "/login/reset-password",
            query: { oobCode }
          };
        default:
          return "/login";
      }
    }
  },
  {
    name: "applink",
    path: "/applink",
    component: AppLink
  },
  {
    name: "familyHubApplink",
    path: "/familyhub/applink",
    component: FamilyHubAppLink
  },
  {
    name: "myHubApplink",
    path: "/myhub/applink",
    component: MyHubAppLink
  },
  {
    name: "DeleteFamilyAccount",
    path: "/familyhub/deleteAccount/:familyUserId/:deleteAccountToken",
    component: DeleteFamilyHubAccount
  },
  {
    name: "set-password",
    path: "/login/set-password/:token",
    component: SetPassword
  },
  {
    path: "/login/forgot-password",
    name: "forgot-password",
    component: ForgotPassword
  },
  {
    name: "new-password",
    path: "/login/reset-password/:token",
    component: ResetPassword
  },
  {
    name: "service-request",
    path: "/serviceRequest/complete/:completeStatusToken",
    component: CompleteServiceRequest
  },
  {
    path: "/",
    name: "Home",
    component: Dashboard,
    meta: { requiresAuth: true, group: RouteGroup.Dashboard  }
  },
  {
    path: "/dashboard/",
    name: "Dashboard",
    component: Dashboard,
    meta: { requiresAuth: true, group: RouteGroup.Dashboard }
  },
  {
    path: "/calendar",
    name: "Calendar",
    component: Calender,
    meta: { requiresAuth: true, group: RouteGroup.Calendar }
  },
  {
    path: "/printable-calendar",
    name: "PrintableCalendar",
    component: PrintableCalendarMain,
    meta: { requiresAuth: true, group: RouteGroup.PrintableCalendar }
  },
  {
    path: "/calendar/create",
    name: "NewCalendarItem",
    component: NewCalendarItem,
    meta: { requiresAuth: true, group: RouteGroup.Calendar }
  },
  {
    path: "/calendar/create/:duplicate",
    name: "DuplicateCalendarItem",
    component: NewCalendarItem,
    meta: { requiresAuth: true, group: RouteGroup.Calendar }
  },
  {
    path: "/calendar/:id",
    name: "ViewCalendarEvent",
    component: ViewCalendarEvent,
    meta: { requiresAuth: true, group: RouteGroup.Calendar }
  },
  {
    path: "/calendar/:id/:editRecurringEventType",
    name: "ViewCalendarRecurringEvent",
    component: ViewCalendarEvent,
    meta: { requiresAuth: true, group: RouteGroup.Calendar }
  },
  {
    path: "/meeting/:eventId",
    name: "Meeting",
    component: Meeting,
    meta: { requiresAuth: true, group: RouteGroup.Calendar }
  },
  {
    path: "/meeting/:eventId/externalHost",
    name: "MeetingExternal",
    component: MeetingExternal,
    meta: { requiresAuth: false, group: RouteGroup.Calendar }
  },
  {
    path: "/externalPerson/email/:email/eventId/:eventId/passcodeHash/:passcodeHash(.*)",
    name: "External Person",
    component: AddToEvent,
    meta: { requiresAuth: false }
  },
  {
    path: "/residents",
    name: "ResidentList",
    component: ResidentList,
    meta: { requiresAuth: true, group: RouteGroup.Residents }
  },
  {
    path: "/family-members",
    name: "FamilyList",
    component: FamilyList,
    meta: { requiresAuth: true, group: RouteGroup.Residents }
  },
  {
    path: "/family-members/:id",
    name: "FamilyView",
    component: FamilyView,
    meta: { requiresAuth: true }
  },
  {
    path: "/broadcasts",
    name: "BroadcastsView",
    component: BroadcastsList,
    meta: { requiresAuth: true }
  },
  {
    path: "/devices",
    name: "DevicesList",
    component: DevicesList,
    meta: { requiresAuth: true }
  },
  {
    path: "/devices/:id",
    name: "DevicesView",
    component: DevicesView,
    meta: { requiresAuth: true }
  },
  {
    path: "/residents/:id",
    name: "ResidentView",
    component: ResidentView,
    meta: { requiresAuth: true, group: RouteGroup.Residents }
  },
  {
    path: "/content-list",
    name: "ContentList",
    component: ContentList,
    meta: { requiresAuth: true, group: RouteGroup.ContentCreator }
  },
  {
    path: "/content-list/:id",
    name: "ContentView",
    component: ContentView,
    meta: { requiresAuth: true, group: RouteGroup.ContentCreator }
  },
  {
    path: "/content-list/:facilityId/v/:id",
    name: "ContentPreview",
    component: ContentPreview,
    meta: { requiresAuth: true, allowExternalViewing: true, group: RouteGroup.ContentCreator }
  },
  {
    path: "/content-list/:facilityId/v/:id/:token",
    name: "ContentPreview",
    component: ContentPreview,
    meta: { requiresAuth: false, allowExternalViewing: true, group: RouteGroup.ContentCreator },
    
  },
  {
    path: "/content-list/:facilityId/v/:id/:token",
    name: "ContentPreview",
    component: ContentPreview,
    meta: { requiresAuth: false, allowExternalViewing: true, group: RouteGroup.ContentCreator },
  },
/*  {
    path: "/content-creator",
    name: "ContentCreatorList",
    component: ContentCreator,
    meta: { requiresAuth: true, group: RouteGroup.ContentCreator }
  },*/
  {
    path: "/content-creator/new",
    name: "Creator",
    component: ContentCreatorEditor,
    meta: { requiresAuth: true, group: RouteGroup.ContentCreator }
  },
  {
    path: "/digital-signage",
    name: "Digital Signage List",
    component: DigitalSignageList,
    meta: { requiresAuth: true, group: RouteGroup.DigitalSignage }
  },
  {
    path: "/digital-signage/:id",
    name: "Digital Signage Edit",
    component: EditDigitalSignage,
    meta: { requiresAuth: true, group: RouteGroup.DigitalSignage }
  },
  {
    path: "/digital-signage/:facilityId/v/:id",
    name: "Digital Signage View",
    component: ViewDigitalSignage,
    meta: { requiresAuth: false, allowExternalViewing: true, group: RouteGroup.DigitalSignage }
  },

  {
    path: "/lifestyle-programs",
    name: "SocialProgramsList",
    component: SocialProgramsList,
    meta: { requiresAuth: true, group: RouteGroup.LifestylePrograms }
  },
  {
    path: "/lifestyle-programs/:id",
    name: "SocialProgramView",
    component: SocialProgramView,
    meta: { requiresAuth: true, group: RouteGroup.LifestylePrograms }
  },
  {
    path: "/create-social-program",
    name: "CreateSocialProgram",
    component: CreateSocialProgram,
    meta: { requiresAuth: true, group: RouteGroup.LifestylePrograms }
  },
/*  {
    path: "/conciergeRequests",
    name: "ConciergeRequests",
    component: ConciergeList,
    meta: { requiresAuth: true, group: RouteGroup.Concierge }
  },
  {
    path: "/conciergeRequests/:id",
    name: "ConciergeRequest",
    component: ConciergeView,
    meta: { requiresAuth: true, group: RouteGroup.Concierge }
  },*/
  {
    path: "/concierge-list",
    name: "ConciergeList",
    component: ConciergeList,
    meta: { requiresAuth: true, group: RouteGroup.Concierge }
  },
  {
    path: "/concierge-events",
    name: "ConciergeEvents",
    component: ConciergeEvents,
    meta: { requiresAuth: true, group: RouteGroup.Concierge }
  },
  {
    path: "/concierge-requests",
    name: "ConciergeRequests",
    component: ConciergeRequests,
    meta: { requiresAuth: true, group: RouteGroup.Concierge }
  },
  {
    path: "/concierge-products",
    name: "ConciergeProducts",
    component: ConciergeProducts,
    meta: { requiresAuth: true, group: RouteGroup.Concierge }
  },
  {
    path: "/concierge-service/:id",
    name: "ConciergeService",
    component: ConciergeService,
    meta: { requiresAuth: true, group: RouteGroup.Concierge }
  },
  {
    path: "/bookings-and-orders/:id",
    name: "RequestDetails",
    component: RequestDetails,
    meta: { requiresAuth: true }
  },
  {
    path: "/maintenanceRequests",
    name: "MaintenanceRequests",
    component: MaintenanceList,
    meta: { requiresAuth: true, group: RouteGroup.Maintenance }
  },

  {
    path: "/maintenanceRequests/:id",
    name: "MaintenanceRequest",
    component: MaintenanceView,
    meta: { requiresAuth: true, group: RouteGroup.Maintenance }
  },
  {
    path: "/scheduledMaintenance",
    name: "MaintenanceScheduledList",
    component: MaintenanceScheduledList,
    meta: { requiresAuth: true, group: RouteGroup.Maintenance }
  },
  {
    path: "/scheduledMaintenance/:id",
    name: "MaintenanceScheduledView",
    component: MaintenanceScheduledView,
    meta: { requiresAuth: true, group: RouteGroup.Maintenance }
  },
  {
    path: "/maintenance-users/set-password/:token",
    name: "SetMaintenanceUserPassword",
    component: SetMaintenanceUserPassword,
    meta: { requiresAuth: false }
  },
  {
    path: "/maintenanceCreateRequest",
    name: "MaintenanceCreateRequest",
    component: MaintenanceCreateRequest,
    meta: { requiresAuth: false, allowExternalViewing: true }
  },
  {
    path: "/supplierManagement",
    name: "VendorList",
    component: VendorList,
    meta: { requiresAuth: true, group: RouteGroup.Maintenance }
  },

  
/*  {
    path: "/premium-services",
    name: "PremiumServices",
    component: PremiumServicesView,
    meta: { requiresAuth: true }
  },*/
  {
    path: "/premium-services-appointments",
    name: "PremiumServicesAppointments",
    component: PremiumServicesAppointments,
    meta: { requiresAuth: true }
  },
  {
    path: "/surveys",
    name: "Surveys",
    component: SurveyList,
    meta: { requiresAuth: true, group: RouteGroup.Surveys }
  },
  {
    path: "/surveys/:id",
    name: "SurveyView",
    component: SurveyView,
    meta: { requiresAuth: true, group: RouteGroup.Surveys }
  },
  {
    path: "/surveys/:id/form/:r/:token",
    name: "SurveyForm By Token",
    component: SurveyForm,
    meta: { requiresAuth: false, allowExternalViewing: true, group: RouteGroup.Surveys }
  },
  {
    path: "/surveys/:id/guestbook/:visitId/visitor/:visitorId/:token",
    name: "Survey Guestbook By Token",
    component: SurveyForm,
    meta: { requiresAuth: false, allowExternalViewing: true, group: RouteGroup.Surveys }
  },
  {
    path: "/surveys/:id/surveyEmail/:visitorRole/:visitorId",
    name: "SurveyEmail",
    component: SurveyForm,
    meta: { requiresAuth: false, allowExternalViewing: true, group: RouteGroup.Surveys }
  },
  {
    path: "/surveys/:id/guestbook/:visitId/visitor/:visitorId",
    name: "SurveyGuestbook",
    component: SurveyForm,
    meta: { requiresAuth: true, group: RouteGroup.Guestbook }
  },
  {
    path: "/survey-create",
    name: "SurveyCreate",
    component: SurveyCreate,
    meta: { requiresAuth: false, group: RouteGroup.Surveys }
  },
  {
    path: "/familyhub/set-password/:token",
    name: "SetPassword",
    component: SetFamilyHubUserPassword,
    meta: { requiresAuth: false }
  },
  {
    path: "/familyhub/reset-password/:token",
    name: "newPassword",
    component: ResetFamilyHubUserPassword,
    meta: { requiresAuth: false }
  },
  {
    path: "/vendors/set-vendor-password/:token",
    name: "VendorSetPassword",
    component: SetVendorPassword,
    meta: { requiresAuth: false }
  },
/*  {
    path: "/vendors/reset-password/:token",
    name: "VendorNewPassword",
    component: ResetFamilyHubUserPassword,
    meta: { requiresAuth: false }
  },*/

  /*{
    path: "/myhub/email-verification/:token", //candidate for deletion
    name: "VerifyResidentEmail",
    component: VerifyResidentEmail,
    meta: { requiresAuth: false }
  },*/
  {
    path: "/familyhub/email-verification/:token",
    name: "VerifyFamilyMemberEmail",
    component: VerifyFamilyMemberEmail,
    meta: { requiresAuth: false }
  },
  {
    path: "/reports",
    name: "Reports", 
    component: ReportList,
    meta: { requiresAuth: true, group: RouteGroup.Reports }
  },
  {
    path: "/reports/reportVisit",
    name: "Visits Report",
    component: VisitsReport,
    meta: { requiresAuth: true, group: RouteGroup.Reports }
  },
  {
    path: "/reports/reportRequests",
    name: "Additional Services Report", 
    component: additionalServiceRequestsReport,
    meta: { requiresAuth: true, group: RouteGroup.Reports }
  },
  {
    path: "/reports/reportRequests/residents",
    name: "Additional Services Report By Resident", 
    component: ConciergeReportByResidents,
    props: { backButtomTitle: i18n.t('ReportRequests.ServiceRequestReport'), backButtonRoute:'/reports/reportRequests'},
    meta: { requiresAuth: true, group: RouteGroup.Reports }
  },
  {
    path: "/reports/reportRequests/type",
    name: "Additional Services Report By Type", 
    component: AdditionalServiceRequestReportByType,
    meta: { requiresAuth: true, group: RouteGroup.Reports }
  },
  {
    path: "/reports/reportEvents", 
    name: "Social Events Report",
    component: SocialEventsReport,
    meta: { requiresAuth: true, group: RouteGroup.Reports }
  },
  {
    path: "/reports/lifestyleEventsReport", 
    name: "Lifestyle Events Report",
    component: LifestyleEventsReport,
    meta: { requiresAuth: true, group: RouteGroup.Reports }
  },
  {
    path: "/reports/lifestyleEventsReport/:facilityId",
    name: "Lifestyle Events Report By Facility",
    component: LifestyleEventsReport,
    meta: { requiresAuth: true, group: RouteGroup.Reports }
  },
  {
    path: "/reports/residentsLifestyleEventsReport",
    name: "Lifestyle Events Report By Residents",
    component: ResidentsLifestyleEventsReport,
    meta: { requiresAuth: true, group: RouteGroup.Reports }
  },
  {
    path: "/reports/adHocActivitiesReport",
    name: "Ad hoc Activities Report",
    component: AdHocActivitiesReport,
    meta: { requiresAuth: true, group: RouteGroup.Reports }
  },
  {
    path: "/reports/adHocActivitiesReport/:residentId",
    name: "Ad hoc Activities per Resident Report",
    component: ResidentAdHocActivitiesReport,
    meta: { requiresAuth: true, group: RouteGroup.Reports }
  },
  {
    path: "/reports/residntsAdHocActivitiesReport",
    name: "Residents ad hoc Activities Report",
    component: ResidentsAdHocActivitiesReport,
    meta: { requiresAuth: true, group: RouteGroup.Reports }
  },
  {
    path: "/reports/reports360",
    name: "reports360",
    component: Report360List,
    meta: { requiresAuth: true, group: RouteGroup.Reports }
  },
  {
    path: "/reports/printableReportResident360/:residentId",
    name: "PrintableResidentReport360",
    component: PrintableResidentReport360,
    meta: { requiresAuth: true, group: RouteGroup.Reports }
  },
  {
    path: "/reports/reports360/:id",
    name: "reports360view",
    component: Report360View,
    meta: { requiresAuth: true, group: RouteGroup.Reports }
  },
  {
    path: "/reports/reports360/:id/events",
    name: "reports360viewEvents",
    component: Report360ViewEvents,
    meta: { requiresAuth: true, group: RouteGroup.Reports }
  },
  {
    path: "/reports/reports360/:id/media",
    name: "reports360viewMedia",
    component: Report360ViewMedia,
    meta: { requiresAuth: true, group: RouteGroup.Reports }
  },
  {
    path: "/reports/reports360/:id/services",
    name: "reports360viewServices",
    component: Report360ViewServices,
    meta: { requiresAuth: true, group: RouteGroup.Reports }
  },
  {
    path: "/reports/report-organisational-health-dashboard/",
    name: "report-organisational-health-dashboard",
    component: ReportOrganisationDashboard,
    meta: { requiresAuth: true, group: RouteGroup.Reports }
  }, 
  {
    path: "/reports/report-community-health-dashboard/",
    name: "report-community-health-dashboard",
    component: ReportCommunityDashboard,
    meta: { requiresAuth: true, group: RouteGroup.Reports }
  },
  {
    path: "/reports/report-maintenance/",
    name: "report-maintenance",
    component: ReportMaintenance,
    meta: { requiresAuth: true, group: RouteGroup.Reports }
  },
  {
    path: "/reports/report-lifestyle-programs-report/",
    name: "report-lifestyle-programs-report",
    component: LifestyleProgramsReport,
    meta: { requiresAuth: true, group: RouteGroup.Reports }
  },
  {
    path: "/reports/premium-service-reports",
    name: "premium-services-report",
    component: PremiumServicesReports,
    meta: { requiresAuth: true, group: RouteGroup.Reports }
  },
  {
    path: "/reports/premium-service-reports/residents",
    name: "premium-services-report-by-residents",
    component: ConciergeReportByResidents,
    props: { backButtomTitle: i18n.t('ReportPremiumServices.PremiumServiceReport'), backButtonRoute:'/reports/premium-service-reports' },
    meta: { requiresAuth: true, group: RouteGroup.Reports }
  },
  /*{
    path: "/reports/family-members-report",
    name: "ReportFamilyMembers",
    component: FamilyMembersReport,
    meta: { requiresAuth: true, group: RouteGroup.Reports }
  }*/
  {
    path: "/reports/family-report",
    name: "ReportFamily",
    component: ReportFamily,
    meta: { requiresAuth: true, group: RouteGroup.Reports }
  },
  {
    path: "/guestbook",
    name: "Guestbook",
    component: GuestBook,
    meta: { requiresAuth: true, group: RouteGroup.Guestbook }
  },
  {
    path: "/guestbook/:id",
    name: "GuestbookVisit",
    component: GuestBookVisit,
    meta: { requiresAuth: true, group: RouteGroup.Guestbook }
  },
  {
    path: "/settings",
    name: "Settings",
    component: Settings,
    meta: { requiresAuth: true }
  },
/*  {
    path: "/services",
    name: "ServiceList",
    component: ServiceList,
    meta: { requiresAuth: true }
  },
  {
    path: "/services/:id",
    name: "ViewService",
    component: ViewService,
    meta: { requiresAuth: true }
  }, */
  {
    path: "/bookings-and-orders",
    name: "BookingsAndOrders",
    component: BookingsAndOrders,
    meta: { requiresAuth: true }
  },
  {
    path: "/contentLibrary",
    name: "ContentLibraryList",
    component: ContentLibraryList,
    meta: { requiresAuth: true, group: RouteGroup.MediaLibrary }
  },
  {
    path: "/contentLibrary/creator/:id",
    name: "ContentLibraryView",
    component: ContentLibraryView,
    meta: { requiresAuth: true, group: RouteGroup.MediaLibrary }
  },

  {
    path: "/premium-services/:id",
    name: "EditPremiumService",
    component: EditPremiumService,
    meta: { requiresAuth: true }
  },

  {
    path: "/messaging",
    name: "Messaging",
    component: Messaging,
    meta: { requiresAuth: true, group: RouteGroup.Messaging }
  },

  {
    path: "/premiumFeatures",
    name: "Premium Features",
    component: PremiumFeatures,
    meta: { requiresAuth: false }
  },
  

  /// BUDDY:
  {
    path: "/buddy/facilities",
    name: "buddyFacilities",
    component: BuddyFacilities,
    meta: { requiresAuth: true, isBuddy: true }
  },

  {
    path: "/buddy/facilities/:id",
    name: "BuddyFacility",
    component: BuddyFacility,
    meta: { requiresAuth: true, isBuddy: true }
  },

  {
    path: "/settings/users/:id",
    name: "User",
    component: UserDetails,
    meta: { requiresAuth: true }
  },
  {
    path: "/settings/emailTemplate/:id",
    name: "EmailTemplateEditor",
    component: EmailTemplateEditor,
    meta: { requiresAuth: true }
  },
  {
    path: "/emailTypeManager",
    name: "EmailTypeManager",
    component: EmailTypeManager,
    meta: { requiresAuth: true }
  },
  {
    path: "/settings/mailingList/:id",
    name: "MailingLists",
    component: MailingView,
    meta: { requiresAuth: true }
  },
  {
    path: "/familyhub/unsubscribe-from-emails/:token",
    name: "UnsubscribeFromEmails",
    component: UnsubscribeFromEmails,
    meta: { requiresAuth: false }
  },
  {
    path: "/gallery",
    name: "gallery",
    component: Gallery,
    meta: { requiresAuth: true, group: RouteGroup.Gallery }
  },
  {
    path: "/gallery/camera-roll",
    name: "GalleryCameraRoll",
    component: GalleryCameraRoll,
    meta: { requiresAuth: true, group: RouteGroup.Gallery }
  },
  {
    path: "/gallery/event-pictures",
    name: "GalleryEventPictures",
    component: GalleryEventPictures,
    meta: { requiresAuth: true, group: RouteGroup.Gallery }
  },
  {
    path: "/gallery/event-pictures/:id",
    name: "GalleryEventPicturesView",
    component: GalleryEventPicturesView,
    meta: { requiresAuth: true, group: RouteGroup.Gallery }
  },
  {
    path: "/gallery/stock-photos",
    name: "GalleryStockPhotos",
    component: GalleryStockPhotos,
    meta: { requiresAuth: true, group: RouteGroup.Gallery }
  },
  {
    path: "/gallery/canva-photos",
    name: "GalleryCanvaPhotos",
    component: GalleryCanvaPhotos,
    meta: { requiresAuth: true, group: RouteGroup.Gallery }
  },
  {
    path: "/gallery/:id",
    name: "GalleryFolderView",
    component: GalleryFolderView,
    meta: { requiresAuth: true, group: RouteGroup.Gallery }
  },
  {
    path: "/documents",
    name: "DocumentsList",
    component: DocumentsList,
    meta: { requiresAuth: true, group: RouteGroup.Documents }
  },
  {
    path: "/documents/:id",
    name: "DocumentView",
    component: DocumentsView,
    meta: { requiresAuth: true, group: RouteGroup.Documents }
  },

  // tv box
  {
    path: "/digital-signage-tv",
    name: "DigitalSignageTV",
    component: DigitalSignageTv,
    meta: { requiresAuth: false, group: RouteGroup.DigitalSignage, allowExternalViewing: true }
  },
  {
    path: "/digital-signage-tv-QR-code",
    name: "DigitalSignageTvQRCode",
    component: DigitalSignageTvQRCode,
    meta: { requiresAuth: false, group: RouteGroup.DigitalSignage, allowExternalViewing: true }
  },
  {
    path: "/digital-signage-tv-login/:id",
    name: "DigitalSignageTVLogin",
    component: DigitalSignageTVLogin,
    meta: { requiresAuth: false, group: RouteGroup.DigitalSignage, allowExternalViewing: true }
  },
  {
    path: "/digital-signage-tv-forgot-password",
    name: "DigitalSignageTVForgotPassword",
    component: DigitalSignageTVForgotPassword,
    meta: { requiresAuth: false, group: RouteGroup.DigitalSignage, allowExternalViewing: true }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  document.body.scrollTo(0, 0);
  window.scrollTo(0, 0);

  const enabledRoutePath = getEnabledRoute(Store?.getters?.premiumFeatures).path

  if(Store?.getters?.user?.isExternalPagesViewing === true && !to?.meta?.allowExternalViewing && to?.name !== 'login' && to?.name !== 'Premium Features'){
    next({
      path: "/login",
      query: { redirect: '/login' }
    })
  }

  if (to.matched.some(record => record.meta.isBuddy)) {
    const ac = Store.getters.user.claims.accessLevel;
    console.log(ac);
    if (ac == "SuperAdmin") {
      next();
    } else {
      next({
        path: "/residents",
        query: { redirect: to.fullPath }
      });
    }
  }

  if (to.matched.some(record => record.meta.isBuddy)) {
    const ac = Store.getters.user.claims.accessLevel;
    console.log(ac);
    if (ac == "SuperAdmin") {
      next();
    } else {
      next({
        path: "/residents",
        query: { redirect: to.fullPath }
      });
    }
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    const claims = Store?.getters?.user?.claims
    if(claims?.customTokenLogin === true && Store?.getters?.user?.isExternalPagesViewing === true){
      const allowedGroups = Store.getters.user.claims?.accessGroups || [];
      const navigatedGroup = to.meta.group;
      if(!allowedGroups.includes(navigatedGroup)){
        Store.dispatch('userSignOut');
        return
      }
    }
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    const claims = Store?.getters?.user?.claims;
    if(claims?.accessLevel === StaffAccessLevels.MaintenanceAdmin) {
      console.log("GROUP ", to.meta.group)
      if(["Maintenance", "Reports"].includes(to.meta.group) || !to.meta.group){
        next()
      } else {
        next({
          path: "/maintenanceRequests",
        })
      }
    }
  }

  if (to.matched.some(record => record.meta.group === RouteGroup.Dashboard) && !Store.getters.premiumFeatures.isStaffHubDashboard) {
    next({ path: enabledRoutePath});
  }

  if (to.matched.some(record => record.meta.group === RouteGroup.Guestbook) && !Store.getters.premiumFeatures.isStaffHubGuestbook) {
     next({ path: enabledRoutePath});
  }

  if (to.matched.some(record => record.meta.group === RouteGroup.Surveys) 
    && !Store.getters.premiumFeatures.isStaffHubSurveys && !to?.meta?.allowExternalViewing) {
     next({ path: enabledRoutePath});
  }

  if (to.matched.some(record => record.meta.group === RouteGroup.Reports) && !Store.getters.premiumFeatures.isStaffHubReporting) {
     next({ path: enabledRoutePath});
  }

  if (to.matched.some(record => record.meta.group === RouteGroup.Maintenance) && !Store.getters.premiumFeatures.isStaffHubMaintenance) {
     next({ path: enabledRoutePath});
  }

  if (to.matched.some(record => record.meta.group === RouteGroup.Concierge) && !Store.getters.premiumFeatures.isStaffHubConcierge) {
     next({ path: enabledRoutePath});
  }

  if (to.matched.some(record => record.meta.group === RouteGroup.LifestylePrograms) && !Store.getters.premiumFeatures.isStaffHubLifestylePrograms) {
     next({ path: enabledRoutePath});
  }

  if (to.matched.some(record => record.meta.group === RouteGroup.ContentCreator) 
    && !Store.getters.premiumFeatures.isStaffHubContentManagerMediaCreator
    && !to?.meta?.allowExternalViewing) {
     next({ path: enabledRoutePath});
  }

  if (to.matched.some(record => record.meta.group === RouteGroup.MediaLibrary) 
    && !Store.getters.premiumFeatures.isStaffHubContentManagerMediaLibrary
    && !to?.meta?.allowExternalViewing) {
     next({ path: enabledRoutePath});
  }

  if (to.matched.some(record => record.meta.group === RouteGroup.DigitalSignage && record.meta.requiresAuth === true) && !Store.getters.premiumFeatures.isStaffHubContentManagerDigitalSignage) {
     next({ path: enabledRoutePath});
  }

  if (to.matched.some(record => record.meta.group === RouteGroup.Gallery) && !Store.getters.premiumFeatures.isStaffHubContentManagerGallery) {
     next({ path: enabledRoutePath});
  }

  if (to.matched.some(record => record.meta.group === RouteGroup.Calendar) && !Store.getters.premiumFeatures.isStaffHubCalendar) {
     next({ path: enabledRoutePath});
  } 

  if (to.matched.some(record => record.meta.group === RouteGroup.Residents) && !Store.getters.premiumFeatures.isStaffHubResidents) {
     next({ path: enabledRoutePath});
  } 

  if (to.matched.some(record => record.meta.group === RouteGroup.PrintableCalendar) && !Store.getters.premiumFeatures.isStaffHubPrintableCalendar) {
     next({ path: enabledRoutePath});
  } 

  if (to.matched.some(record => record.meta.group === RouteGroup.Messaging) && !Store.getters.premiumFeatures.isStaffHubMessenger) {
     next({ path: enabledRoutePath});
  }

  if (to.matched.some(record => record.meta.group === RouteGroup.Documents) && !Store.getters.premiumFeatures.isStaffHubDocuments) {
    next({ path: enabledRoutePath});
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!Store.getters.isAuthenticated) {
      next({
        path: "/login",
        query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  } else {
    next(); // make sure to always call next()!
  }
});

export default router;